// extracted by mini-css-extract-plugin
export default {"invitation":"Invitation_invitation__NtG++"};